// src/pages/EditProfilePage.js
import React, { useContext, useState, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { updateMe } from "../services/users.api";

function EditProfilePage() {
  const { lang } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    full_name: "",
    phone: "",
    email: "",
    city: "",
    area: "",
    street: "",
    building: "",
  });

    const [phoneTouched, setPhoneTouched] = useState(false);

  const formatLbLocal = (digits) => {
    const d = digits.slice(0, 8);
    const p1 = d.slice(0, 2);
    const p2 = d.slice(2, 5);
    const p3 = d.slice(5, 8);
    return [p1, p2, p3].filter(Boolean).join(" ");
  };

  const formatLbPlus961 = (digitsAfter961) => {
    const d = digitsAfter961.slice(0, 8);
    const p1 = d.slice(0, 2);
    const p2 = d.slice(2, 5);
    const p3 = d.slice(5, 8);
    const parts = [p1, p2, p3].filter(Boolean).join(" ");
    return parts ? `+961 ${parts}` : "+961";
  };

  const formatPhoneInput = (raw) => {
    const v = (raw || "").trim();

    // +961 formatting
    if (v.startsWith("+961")) {
      const after = v.replace(/\s/g, "").slice(4);
      const digits = after.replace(/\D/g, "");
      return formatLbPlus961(digits);
    }

    // Local LB formatting (0 / 7 / 8)
    const first = v.replace(/\s/g, "").charAt(0);
    if (first === "0" || first === "7" || first === "8") {
      const digits = v.replace(/\D/g, "").slice(0, 8);
      return formatLbLocal(digits);
    }

    // International → untouched
    return raw;
  };

  const validatePhone = (value) => {
    const v = (value || "").trim();

    if (v.startsWith("+961")) {
      const compact = v.replace(/\s/g, "");
      const digits = compact.slice(4).replace(/\D/g, "");
      if (digits.length !== 8) {
        return "Phone must be +961 followed by 8 digits.";
      }
      return null;
    }

    const compact = v.replace(/\s/g, "");
    const first = compact.charAt(0);

    if (first === "0" || first === "7" || first === "8") {
      const digits = compact.replace(/\D/g, "");
      if (digits.length !== 8) {
        return "Phone must be exactly 8 digits.";
      }
      return null;
    }

    // International → allowed
    return null;
  };


  useEffect(() => {
  const user = JSON.parse(localStorage.getItem("esill-user"));
  if (!user) return;

  const rawPhone = user.phone || "";
  const rawEmail = user.email || "";
  const phoneLooksLikeEmail = rawPhone.includes("@");

  setForm({
    ...user,
    phone: phoneLooksLikeEmail ? "" : rawPhone,
    email: rawEmail || (phoneLooksLikeEmail ? rawPhone : ""),
  });
}, []);


  const TEXT = {
    EN: {
      title: "Edit Profile",
      save: "Save Changes",
      back: "×",
      placeholders: {
        full_name: "Full Name",
        phone: "Phone Number",
        email: "Email",
        city: "City",
        area: "Area",
        street: "Street",
        building: "Building",
      },
    },
    AR: {
      title: "تعديل الملف",
      save: "حفظ التغييرات",
      back: "×",
      placeholders: {
        full_name: "الاسم الكامل",
        phone: "رقم الهاتف",
        email: "البريد الإلكتروني",
        city: "المدينة",
        area: "المنطقة",
        street: "الشارع",
        building: "المبنى",
      },
    },
  };

  const t = TEXT[lang];

  const handleChange = (key, val) => {
    setForm((prev) => ({ ...prev, [key]: val }));
  };

  const save = async () => {
  setPhoneTouched(true);

  const phoneError = validatePhone(form.phone);
  if (phoneError) return;

    try {
      const updated = await updateMe({
        full_name: form.full_name,
        phone: form.phone,
        email: form.email,
        city: form.city,
        area: form.area,
        street: form.street,
        building: form.building,
      });

      localStorage.setItem("esill-user", JSON.stringify(updated));
      navigate("/account");
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div
      className="w-full min-h-screen bg-white pt-[95px] px-5 pb-24"
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      <button
        onClick={() => navigate(-1)}
        className="absolute top-[80px] left-4 text-3xl opacity-60 hover:opacity-100"
      >
        {t.back}
      </button>

      <h1 className="text-xl font-semibold text-center">{t.title}</h1>
      <div className="h-[2px] w-16 bg-black mx-auto mt-2 mb-6"></div>

      <div className="flex flex-col gap-4 max-w-xl mx-auto">
        <input
          value={form.full_name}
          onChange={(e) => handleChange("full_name", e.target.value)}
          placeholder={t.placeholders.full_name}
          className="checkout-input"
        />
        <input
  value={form.phone}
  onChange={(e) =>
    handleChange("phone", formatPhoneInput(e.target.value))
  }
  onBlur={() => setPhoneTouched(true)}
  placeholder={t.placeholders.phone}
  className="checkout-input"
/>
{phoneTouched && validatePhone(form.phone) && (
  <p className="text-xs text-red-600">
    {validatePhone(form.phone)}
  </p>
)}


        <input
          value={form.email}
          onChange={(e) => handleChange("email", e.target.value)}
          placeholder={t.placeholders.email}
          className="checkout-input"
        />
        <input
          value={form.city}
          onChange={(e) => handleChange("city", e.target.value)}
          placeholder={t.placeholders.city}
          className="checkout-input"
        />
        <input
          value={form.area}
          onChange={(e) => handleChange("area", e.target.value)}
          placeholder={t.placeholders.area}
          className="checkout-input"
        />
        <input
          value={form.street}
          onChange={(e) => handleChange("street", e.target.value)}
          placeholder={t.placeholders.street}
          className="checkout-input"
        />
        <input
          value={form.building}
          onChange={(e) => handleChange("building", e.target.value)}
          placeholder={t.placeholders.building}
          className="checkout-input"
        />

        <button
          onClick={save}
          className="mt-4 w-full py-3 bg-black text-white rounded-md text-lg font-semibold hover:bg-[#222]"
        >
          {t.save}
        </button>
      </div>
    </div>
  );
}

export default EditProfilePage;
